export const EVENT_ACTION=[
    {
        label:'消费',
        value:'sub'
    },
    {
        label:'获得',
        value:'add'
    }
]